import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';

export default class LimitDriverWithLessProPlan extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.props.onClickClose();
    }
  };

  openPlanHeaderModal = () => {
    const toggleBtn = $('#plan-header-toggle-btn');
    if(toggleBtn && toggleBtn.length > 0) {
      toggleBtn.trigger('click');
    }
    else {
      window.open(Routes.owner_total_info_path());
    }
  }

  renderModal() {
    const { isOpen, onClickClose, currentPlan } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={onClickClose} innerRef={node => (this.modalRef = node)} id='gdrive-file-deleted' className="animation-uploader-modal modal-dialog-centered modal-style confirm-submit-modal">
        <ModalBody className='plan-limit-modal-body mt-2' style={{paddingTop: '10px'}}>
          <div className='mobile text-white'><span className='d-xx-inline-block d-none'>Googleドライブ機能は、</span>Proプラン以上のチームアカウントでご利用いただけます。 </div>
          <div className='mobile text-white'> 現在ご利用中のプランは{currentPlan}プランのため、本機能はご利用いただけません。</div>
          <div className="text-center mt-3">
            <a href="#" onClick={this.openPlanHeaderModal} className="btn btn-primary btn-transition-contract">
              <span className="text-black font-weight-bold">プランを変更する</span>
            </a>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    return this.renderModal();
  }
};
